import React, { useContext, useRef, useState } from 'react';
import { BsSearch } from 'react-icons/bs';
import { FiUser, FiSliders } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import { UserContext } from '../App';
import logo from '../images/happytimes.png';
import SearchInput from './search/SearchInput';
import ThemeToggle from './ThemeToggle';

export default function Header({ searchOnly = false }) {
  const { pathname } = useLocation();
  const user = useContext(UserContext);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchTrigger = useRef(null);
  const closeSearch = () => {
    setSearchOpen(false);
    requestAnimationFrame(() => searchTrigger.current?.focus());
  };
  const search = <>
      <button ref={searchTrigger} className="site-search-trigger" type="button" onClick={() => setSearchOpen(true)} aria-label="Search people and creators" aria-haspopup="dialog" aria-expanded={searchOpen}>
        <BsSearch aria-hidden="true" /><span>Find memes, hashtags, accounts, …</span><FiSliders aria-hidden="true" />
      </button>
      {searchOpen && <SearchInput setSearchModal={closeSearch} />}
    </>;
  if (searchOnly) return <div className="feed-search">{search}</div>;
  return <header className="site-header">
    <div className="site-header-inner">
      <Link to="/" className="site-brand" aria-label="HappyTimes home">
        <span className="site-brand-mark"><img className="giggle-logo" src={logo} alt="" width="32" height="32" /></span>
        <span className="site-brand-copy"><span className="site-brand-name">Happy Times</span><span className="site-brand-caption">Memes</span></span>
      </Link>
      {!['/', '/foryou', '/global'].includes(pathname.toLowerCase()) && search}
      <ThemeToggle />
      <Link to="/account" className="site-account-link" aria-label={user ? 'Your account' : 'Sign in'}>
        <FiUser aria-hidden="true" /><span>{user ? 'Your account' : 'Sign in'}</span>
      </Link>
    </div>
  </header>;
}
